import { Cell } from './TableCell.styled';
import type { TableCellProps } from './types';

export const TableCell = ({ children, className, ...props }: TableCellProps) => (
  <Cell className={className} {...props}>
    {children}
  </Cell>
);
